var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, Defaults, P, PCSS, Components, CustomTypedEvent, PropertyConverters, Watch, Utils, ViewChild } from '@pacem/pacem-core';
import { PacemDataSourceElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
class TagRemoveEvent extends CustomTypedEvent {
    constructor(value) {
        super('tagremove', { index: value });
    }
}
class TagAddEvent extends CustomTypedEvent {
    constructor(value) {
        super('tagadd', { value: value });
    }
}
let PacemTagElement = class PacemTagElement extends Components.PacemElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'readonly':
                let readonly = !!val;
                (readonly ? Utils.addClass : Utils.removeClass)(this, 'tag-readonly');
                this._btn.disabled = this._btn.hide = readonly;
                break;
            case 'tag':
                Utils.removeClass(this, 'tag-out');
                break;
        }
    }
    _remove() {
        const tag = this;
        Utils.addClass(tag, 'tag-out');
        Utils.addAnimationEndCallback(tag, () => {
            this.dispatchEvent(new Event("remove"));
        });
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemTagElement.prototype, "tag", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemTagElement.prototype, "readonly", void 0);
__decorate([
    ViewChild(P + '-button')
], PacemTagElement.prototype, "_btn", void 0);
PacemTagElement = __decorate([
    CustomElement({
        tagName: P + '-tag', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-text text="{{ :host.tag }}"></${P}-text>
                <${P}-button on-click=":host._remove()"></${P}-button>`
    })
], PacemTagElement);
export { PacemTagElement };
let PacemTagsElement = class PacemTagsElement extends PacemDataSourceElement {
    constructor() {
        super(true);
        this.inputFields = [];
    }
    toggleReadonlyView(readonly) {
        this._suggest.readonly = readonly;
        this.querySelector('.tag-new').hidden = readonly;
    }
    _tagRemove(ndx) {
        this.changeHandler(new TagRemoveEvent(ndx));
    }
    _tagAdd(v) {
        this.changeHandler(new TagAddEvent(v));
        // after the - just in case - assignment => reset the suggest component
    }
    handleDatasourceMismatch() {
        // do nothing!
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'datasource':
            case 'textProperty':
                this._suggest[name] = val;
                break;
            case 'valueProperty':
                // DON't pass the value-property to the suggest
                if (!Utils.isNullOrEmpty(val)) {
                    throw `Cannot set 'valueProperty' on ${this.constructor.name}s.`;
                }
                break;
            case 'value':
                this._tags.datasource = val;
                break;
        }
    }
    onChange(evt) {
        return new Promise((resolve, reject) => {
            switch (evt.type) {
                case 'tagremove':
                    this._justAddedIndex = -1;
                    const trev = evt, ndxrev = trev.detail.index, 
                    // manipulate a copy of the array (to preserve the originalValue)
                    valrev = Utils.clone(this.value);
                    const trunk2 = valrev.splice(ndxrev + 1), trunk1 = valrev.splice(0, ndxrev);
                    resolve(this.value = trunk1.concat(trunk2));
                    break;
                case 'tagadd':
                    const value = evt.detail.value, 
                    // manipulate a copy of the array (to preserve the originalValue)
                    valadd = Utils.clone(this.value);
                    if ( // no empty items
                    !Utils.isNullOrEmpty(value)
                        // no duplicated items
                        && (this.allowDuplicates || Utils.isNullOrEmpty(valadd && valadd.find(i => this.mapEntityToViewValue(i) == this.mapEntityToViewValue(value))))) {
                        let newvalue = (valadd || []).concat([value]);
                        resolve(this.value = newvalue);
                        this._justAddedIndex = this.value.length - 1;
                        setTimeout(() => {
                            this._suggest.focus();
                        }, 250);
                        // this will allow to accept the hint change...
                        this._suggest.blur();
                        this._suggest.hint = '';
                        this._suggest.reset();
                    }
                    break;
                default:
                    resolve(this.value);
                    break;
            }
        });
    }
    acceptValue(val) {
        // no need to implement
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemTagsElement.prototype, "hint", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemTagsElement.prototype, "allowDuplicates", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemTagsElement.prototype, "allowNew", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemTagsElement.prototype, "_justAddedIndex", void 0);
__decorate([
    ViewChild(P + '-suggest')
], PacemTagsElement.prototype, "_suggest", void 0);
__decorate([
    ViewChild(P + '-repeater.' + PCSS + '-tags')
], PacemTagsElement.prototype, "_tags", void 0);
PacemTagsElement = __decorate([
    CustomElement({
        tagName: P + '-tags', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-repeater class="${PCSS}-tags">
    <ul class="${PCSS}-tags ${PCSS}-viewfinder ${PCSS}-list list-unstyled list-inline">
        <template>
            <li class="${PCSS}-tag">
                <${P}-tag on-remove=":host._tagRemove(^index)" css-class="{{ { 'tag-in': :host._justAddedIndex === ^index } }}" tag="{{ :host.mapEntityToViewValue(^item) }}" readonly="{{ :host.readonly }}"></${P}-tag>
            </li>
        </template>
        <li class="tag-new">
            <${P}-suggest logger="{{ :host.logger }}" placeholder="{{ :host.placeholder }}" allow-new="{{ :host.allowNew }}" class="${PCSS}-tags" on-change=":host._tagAdd($this.value)" hint="{{ :host.hint, twoway }}">
                <${P}-content></${P}-content>
            </${P}-suggest>
        </li>
    </ul>
</${P}-repeater>`
    })
], PacemTagsElement);
export { PacemTagsElement };
